import React from 'react';
import {useAppSelector} from "common/hook";
import {getCabinetData} from "entities/Cabiner/model/selectors/getCabinetData/getCabinetData";
import {MY_LEVEL, ROLE_DEMO_STUDENT} from "entities/constants/constants";
import {
    RadialStatisticItemSmall
} from "../../../../../groups/group-container/students/students-pages/students-statistic/radial-statisti-item-small/RadialStatisticItemSmall";
import {ReactComponent as PatternBgIcon} from '../../../../../../../assets/main/statistics/pattern-bg.svg';
import {ReactComponent as CrownIcon} from '../../../../../../../assets/main/statistics/crown.svg';
import {ReactComponent as PatternIcon} from '../../../../../../../assets/main/statistics/pattern.svg';
import {ReactComponent as StatArrayIcon2} from '../../../../../../../assets/main/groups/students/statistic2-array.svg';
import {
    ReactComponent as CircleStatisticsArrayIcon
} from '../../../../../../../assets/main/groups/students/circle-statistics-array.svg';
import {NothingYetMessage} from "../../../../nothing-yet-message/NothingYetMessage";
import {
    CefrLevelsComponent
} from "../../../../../groups/group-container/students/students-pages/students-statistic/cefr-levels-component/CefrLevelsComponent";


export const LevelCart = () => {
    const cabinetData = useAppSelector(getCabinetData);
    const roleType = useAppSelector((state) => state.role.roleType);
    const myLevel = cabinetData?.myLevel;

    const beginLanguageLevel = myLevel?.levelStart
    const currentLanguageLevel = myLevel?.levelEnd

    const arrowIcon1 = <CircleStatisticsArrayIcon/>;
    const arrowIcon2 = <StatArrayIcon2/>;

    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h4">{MY_LEVEL}</p>
                </div>
            </div>
            <div className="info-card-content">
                {myLevel ? (
                    <>
                        <div className="levels-data-box">
                            <CefrLevelsComponent
                                beginLanguageLevel={beginLanguageLevel}
                                currentLanguageLevel={currentLanguageLevel}
                                editVisible={false}
                                arrowIcon1={arrowIcon1}
                                arrowIcon2={arrowIcon2}
                            />

                            <div className="slogan">
                                <div className="sub-box">
                                    <CrownIcon/>
                                    <p>Keep Calm<br/> and<br/> Carry On</p>
                                </div>
                                <PatternIcon/>
                            </div>
                            <div className="pattern-bg">
                                <PatternBgIcon/>
                            </div>
                        </div>
                        {roleType !== ROLE_DEMO_STUDENT && (
                            (myLevel?.homework !== null || myLevel?.lastCut !== null) && (
                                <div className="radial-statistic-box">
                                    {myLevel?.homework !== null && (
                                        <RadialStatisticItemSmall
                                            label="Домашнее задание"
                                            value={myLevel?.homework}
                                            gradientId="linearColorsSrez"
                                            id="homework"
                                        />
                                    )}
                                    {myLevel?.lastCut !== null && (
                                        <RadialStatisticItemSmall
                                            label="Последний срез"
                                            value={myLevel?.lastCut}
                                            gradientId="linearColorsEfficiency"
                                            id="lastCut"
                                        />
                                    )}
                                </div>
                            )
                        )}


                    </>
                ) : (
                    <NothingYetMessage/>
                )}
            </div>
        </div>
    );
};
